import type { NextPage } from 'next'
import ProjectList, { ProjectListType } from '@components/project/ProjectList'
import HistoryDialog from '@components/historyDialog/HistoryDialog'
import ErrorDialog from '@components/studio/ErrorDialog'
import PrivateBetaSurveyToast from '@components/privateBetaSurveyToast/PrivateBetaSurveyToast'
import { useProjectState } from '@hooks/useProject'
import SettingsDialog from '@components/settingsDialog/SettingsDialog'
import { LegalNoticesDialog } from '@components/legalNoticesDialog/LegalNoticesDialog'

const DiscoverPage: NextPage = () => {
  const browserCompatibility = useProjectState('browserCompatibility')

  return (
    <>
      {browserCompatibility === 'Compatible' && <HistoryDialog />}
      <ProjectList projectListType={ProjectListType.Community} />
      <ErrorDialog isStudioPage={false} />
      <SettingsDialog />
      <LegalNoticesDialog />
      <PrivateBetaSurveyToast />
    </>
  )
}

export default DiscoverPage
